<template>
  <div>
    <div id="app">
      <side-nav v-if="showSideNav"/>
      <main-window :class="{ 'nav-open': showSideNav }"/>
    </div>
    <dialogs-wrapper class="modal-dialogs" transition-name="fade"/>
    <modal-wrapper/>
    <toaster position="bottom center" :max="1"/>
  </div>
</template>
<script>
import SideNav from './layout/SideNav'
import MainWindow from './layout/MainWindow'

export default {
  
  components: {
    SideNav,
    MainWindow
  },

  data: () => ({
    showSideNav: false
  }),

  methods: {
    setSideNav() {
      if(this.$route.name !== 'login' && this.$route.name !== 'signup' && this.$route.name !== 'device') {
        this.showSideNav = true
      } else {
        this.showSideNav = false
      }
    }
  },

  watch: {
    '$route': 'setSideNav'
  }

}
</script>

<style lang="scss">
@import "./assets/scss/app.scss";
</style>
